<template>
	<div class="filters-box">
		<div class="filters-box-row">
			<div class="data-picker-box">
				<span>时间周期：</span>
				<el-date-picker
					v-model="dateValue"
					size="small"
					type="daterange"
					align="right"
					unlink-panels
					:clearable='false'
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					value-format="yyyy-MM-dd">
				</el-date-picker>
			</div>
			<!-- <div class="business-name-box">
				<span>采购门店名称：</span>
				<el-input v-model="businessNameValue" placeholder="请输入采购门店名称" class="business-name-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div> -->
			<div class="shop-name-box">
				<span>供货商店铺名称：</span>
				<el-input v-model="shopNameValue" placeholder="请输入供货商店铺名称：" class="shop-name-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'FiltersBox',
	data () {
		return {
			dateValue: [],
			businessNameValue: '',
			shopNameValue: ''
		}
	},
	created () {
		if (!this.$fxUtils.isEmptyObjSHW(this.$route.query)) {
			let throughParams = this.$fxUtils.JSONparse(this.$route.query.throughParams)
			if (throughParams) {
				this.businessNameValue = (throughParams.entname && throughParams.entname.value) || ''
				let startDate = throughParams.startDate.value.split(' ')
				let endDate = throughParams.endDate.value.split(' ')
				this.dateValue = [startDate[0], endDate[0]]
			}
		} else {
			this.dateValue = [this.$fxUtils.getCurrentMonthFirst(), this.$fxUtils.getCurrentMonthLast()]
		}
	},
	methods: {
		inputEnterHandle () {
			this.$emit('inputEnter')
		},
		getFiltersParams () {
			let filtersParams = []
			let cParams = []
			if (this.dateValue === '' ||
				this.dateValue === null ||
				this.dateValue === undefined) {
				filtersParams = [
					{ field: 'createDate', data: `${this.$fxUtils.getCurrentMonthFirst()} 00:00`, 'op': 'ge' },
					{ field: 'createDate', data: `${this.$fxUtils.getCurrentMonthLast()} 23:59`, 'op': 'le' }
				]
			} else {
				filtersParams = [
					{ field: 'createDate', data: `${this.dateValue[0]} 00:00`, 'op': 'ge' },
					{ field: 'createDate', data: `${this.dateValue[1]} 23:59`, 'op': 'le' }
				]
			}
			if (this.businessNameValue) {
				let businessName = { field: 'entname', data: this.businessNameValue, 'op': 'cn' }
				filtersParams.push(businessName)
			}
			if (this.shopNameValue) {
				let shopName = { field: 'name', data: this.shopNameValue, 'op': 'cn' }
				filtersParams.push(shopName)
			}
			return {
				filtersParams,
				cParams
			}
		},
		getFiltersDate () {
			return [
				{ name: 'startDate', field: 'createDate', value: `${this.dateValue[0]} 00:00`, 'op': 'ge', type: 'filtersParams' },
				{ name: 'endDate', field: 'createDate', value: `${this.dateValue[1]} 23:59`, 'op': 'le', type: 'filtersParams' }
			]
		}
	}
}
</script>
<style lang="stylus" scoped>
.filters-box {
	width:100%
	.filters-box-row {
		display:flex
		margin-bottom: 10px
		&:last-child {
			margin-bottom: 0px
		}
		.data-picker-box {
			margin-right: 20px
		}
		.business-name-box {
			margin-right: 20px
			.business-name-input {
				width: 150px
			}
		}
		.shop-name-box {
			.shop-name-input {
				width: 150px
			}
		}
	}
}
</style>
